import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, selectRoles } from './authSlice';

export default function ProtectedRoute({ children, roles }) {
  const isAuth = useSelector(selectIsAuthenticated);
  const userRoles = useSelector(selectRoles);
  const loc = useLocation();

  if (!isAuth) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (roles && roles.length && !userRoles.some((r) => roles.includes(r))) {
    return (
      <div className="empty-state">
        <h3>Access denied</h3>
        <p>You don't have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
